// extracted by css-extract-rspack-plugin
export default {"headerLink":"src-modules-auth-templates-AuthPageTemplate-HeaderLink-HeaderLink-module__headerLink-pIO8D9","label":"src-modules-auth-templates-AuthPageTemplate-HeaderLink-HeaderLink-module__label-suhjeX","active":"src-modules-auth-templates-AuthPageTemplate-HeaderLink-HeaderLink-module__active-V252kG"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"headerLink\":\"src-modules-auth-templates-AuthPageTemplate-HeaderLink-HeaderLink-module__headerLink-pIO8D9\",\"label\":\"src-modules-auth-templates-AuthPageTemplate-HeaderLink-HeaderLink-module__label-suhjeX\",\"active\":\"src-modules-auth-templates-AuthPageTemplate-HeaderLink-HeaderLink-module__active-V252kG\"}";
        // 1793872698158
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  